import { DaikinFormData } from "./DaikinFormData";

export const initialValues: DaikinFormData = {
  // address: '38 Ewing Street',
  // full_address: '38 Ewing Street, Brunswick VIC, Australia',
  // lat: -37.7731789,
  // locality: 'Brunswick',
  // lon: 144.9678306,
  // state: 'VIC',
  // zip: '3056',
  // your_email: 'tritruong.dev@gmail.com',
  // first_name: 'Truong',
  // last_name: 'Nhan',
  // phone_number: '0123 456 789',
  country_iso2: 'Australia',
  prepared_by: 'PE Admin',
  info_pack: 'no',
  scope_pdf: 'no',
}